import script from "./GGanttGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttGrid.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttGrid.vue?vue&type=style&index=0&id=bb532294&lang=css"

const __exports__ = script;

export default __exports__